import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api-platform.meiso-shoji.co.jp/kanako',  // 実際のAPIサーバーのアドレス
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

api.interceptors.request.use(
    config => {
        config.params = config.params || {};
        config.params.div = '2';
        return config;
    }
);

// レスポンスインターセプター
api.interceptors.response.use(
    response => {
        // APIからのレスポンスを直接返す
        return response.data;
    },
    error => {
        console.error('API Error:', error);
        return Promise.reject(error);
    }
);

export default api; 